import { Flex, Text } from "@/atoms"
import { CheckOutlined, CopyOutlined } from "@/icons"

import styles from "./SourceList.module.scss"

import type { CopyFixCommandButtonProps } from "."

export const CopyFixCommandButton = ({
  t,
  key,
  fixCommand,
  noLimits
}: CopyFixCommandButtonProps) => {
  if (noLimits || !fixCommand) {
    return null
  }

  return (
    <Text
      className={styles.copyFixCommand}
      copyable={{
        text: fixCommand,
        icon: [
          <Flex key={`${key}_copy`} gap={4}>
            <CopyOutlined />
            <span className={styles.copyFixCommandText}>
              {t("general.command")}
            </span>
          </Flex>,
          <Flex key={`${key}_copied`} gap={4}>
            <CheckOutlined />
            <span>{t("general.command")}</span>
          </Flex>
        ],
        tooltips: [
          t("general.copyFixCommand"),
          t("general.copyFixCommandCopied")
        ]
      }}
    />
  )
}
